import { TagContent, TagStyle } from '../types/tags';

class Tags {
  id: TagContent;

  style: TagStyle;

  content: string;

  constructor(id: TagContent, style: TagStyle, content: string) {
    this.id = id;
    this.style = style;
    this.content = content;
  }
}

export default Tags;
